/**
 * The MCP endpoint URL and the connect command shown on the account page.
 *
 * Kept out of the component so the exact strings are testable: the endpoint
 * has to match the server's configured audience byte for byte, or the token a
 * client obtains is minted for the wrong resource and every call 401s.
 */

const DEFAULT_API_ORIGIN = 'https://api.formshive.com';

/**
 * `<api origin>/mcp`.
 *
 * Derived from the *origin* of the API base URL, not the base URL itself:
 * `VITE_API_BASE_URL` carries the `/v1` prefix (`http://localhost:8003/v1`),
 * and the MCP endpoint is mounted at the root, sibling to the `/v1` scopes.
 * Appending to the base would advertise `/v1/mcp`, which 404s.
 */
export function mcpEndpointUrl(apiBaseUrl?: string): string {
  const raw = apiBaseUrl?.trim();
  if (!raw) {
    return `${DEFAULT_API_ORIGIN}/mcp`;
  }
  try {
    return `${new URL(raw).origin}/mcp`;
  } catch {
    // Not absolute (a relative base such as `/v1` in some dev setups): fall
    // back to the page's own origin rather than emitting something unusable.
    const origin = typeof window === 'undefined' ? DEFAULT_API_ORIGIN : window.location.origin;
    return `${origin}/mcp`;
  }
}

/** The one-liner a user pastes into a terminal to connect Claude Code. */
export function mcpConnectCommand(endpointUrl: string): string {
  return `claude mcp add --transport http formshive ${endpointUrl}`;
}
